import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import basicsStyle from "assets/jss/material-kit-react/views/componentsSections/basicsStyle.jsx";
import PostCard from "../Custome/PostCard";
import InfoCard from "../Custome/InfoCard";
import Grid from "@material-ui/core/Grid";
import { API } from "../config/config";
import axios from "axios";
import SearchPost from "../AllPosts/SearchPost";
import { Spiner } from "../Spinner/Spinner";
import Button from "components/CustomButtons/Button.jsx";
import Slide from "react-reveal/Slide";

class SectionBasics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: [],
      infos: [],
      message_error: "",
      loading: false
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });
    try {
      const getposts = {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: false,
        credentials: "same-origin",
        url:
          API +
          "/api/Posts/Post?order_by_field=created_at&order_by_direction=ACS"
      };
      let responsepost = await axios(getposts);
      // console.log(responsepost)
      if (responsepost.status === 200) {
        // console.log('post');
        // console.log(responsepost.data.results.data);
        // console.log('------------');
        this.setState({ posts: responsepost.data.results.data });
      } else {
        // console.log('get-post-error');
        // console.log(responsepost);
      }
    } catch (err) {
      console.log(err);
      this.setState({
        message_error:
          "متاسفانه مشکلی در دریافت اطلاعات بوجود آمده لطفا دوباره سعی نمایید."
      });
    }

    try {
      const getinfo = {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: false,
        credentials: "same-origin",
        body: {
          order_by_field: "created_at",
          order_by_direction: "ACS"
        },
        url: API + "/api/Ims/GetIms"
      };
      let responseinfo = await axios(getinfo);
      // console.log('market')
      // console.log(responseinfo);
      // console.log('------------');
      if (responseinfo.status === 200) {
        // console.log(responseinfo.data.results);
        this.setState({ infos: responseinfo.data.results });
      } else {
        console.log("get-market-error");
        console.log(responseinfo);
      }
    } catch (err) {
      this.setState({
        message_error:
          "متاسفانه مشکلی در دریافت اطلاعات بوجود آمده لطفا دوباره سعی نمایید."
      });
    }
    this.setState({ loading: false });
  }
  searchpost(e) {
    window.location.replace("/posts?" + e);
  }
  nextmarket() {
    window.location.replace("/market");
  }
  nextPosts() {
    window.location.replace("/posts");
  }

  render() {
    const { posts, infos, loading } = this.state;

    return (
      <div className="material-sections">
        {loading && <Spiner />}
        <div className="material-container">
          <Slide bottom>
            <Grid container className={"home-main-grid"} spacing={16}>
              <SearchPost get={this.searchpost.bind(this)} />
            </Grid>
          </Slide>
          <Grid container className={"home-main-grid"} spacing={16}>
            {posts !== undefined && posts.length !== 0 && (
              <Grid item xs={12} md={8}>
                <Slide bottom>
                  <h5 className="title-home">
                    قیمت خرید قراضه آهن تحویل کارخانه{" "}
                  </h5>
                  <div className="homepost-div">
                    {posts.map((post, i) => (
                      <PostCard post={post} key={i} />
                    ))}
                  </div>
                  <div className="olderposthome">
                    <Button
                      className="nex-but"
                      onClick={this.nextPosts.bind(this)}
                    >
                      پست های قبلی قیمت
                    </Button>
                  </div>
                </Slide>
              </Grid>
            )}
            {infos.length !== 0 && (
              <Grid item xs={12} md={4}>
                <Slide bottom>
                  <h5 className="title-home">اطلاعات بازار قراضه</h5>
                  <div className="homepost-div">
                    {infos.map((info, i) => (
                      <InfoCard info={info} key={i} />
                    ))}
                  </div>
                  <div className="olderposthome">
                    <Button className="nex-but" onClick={this.nextmarket}>
                      پست های قبلی اطلاعات بازار
                    </Button>
                  </div>
                </Slide>
              </Grid>
            )}
          </Grid>
        </div>
      </div>
    );
  }
}

export default withStyles(basicsStyle)(SectionBasics);
